export const EXAMPLE_ARTICLES: { [lang: string]: any } = {
  en: {
    id: 'en',
    language: 'en',
    title: { 
      en: { 
        1: 'EZ Knews: Global news, easy language', 
        2: 'EZ Knews: Global news, easy language', 
        3: 'EZ Knews: Global news, easy language' 
      } 
    },
    articleText: { 
      en: { 
        1: `Learning a foreign language is difficult when you're not immersed in the language every day. Even if you know some grammar, understanding real texts can be hard. With EZ Knews, it's different. EZ Knews helps beginners keep up with the news and read articles in their target language by offering simplified articles that are easy to understand. Let's go!`,
        2: `Learning a foreign language can be challenging if you don't use it daily. Even with basic grammar, reading everyday texts or media is tough. EZ Knews changes that. It helps beginner learners follow the news and read articles in their target language by providing simplified articles that are easy to understand, even for those just starting out. Let's get started!`,
        3: `Mastering a foreign language is tough without daily immersion. Beginners may know grammar, but real-world texts and media are often difficult. EZ Knews solves this by making news accessible to language learners. With simplified articles, you can keep up with global events and improve your skills, no matter your level. Start your journey with EZ Knews today!`
      } 
    },
    tokenizedArticle: { 
      en: { 
        1: [
          ["Learning", "a", "foreign", "language", "is", "difficult", "when", "you're", "not", "immersed", "in", "the", "language", "every", "day."],
          ["Even", "if", "you", "know", "some", "grammar,", "understanding", "real", "texts", "can", "be", "hard."],
          ["With", "EZ Knews,", "it's", "different."],
          ["EZ Knews", "helps", "beginners", "keep", "up", "with", "the", "news", "and", "read", "articles", "in", "their", "target", "language", "by", "offering", "simplified", "articles", "that", "are", "easy", "to", "understand."],
          ["Let's", "go!"]
        ],
        2: [
          ["Learning", "a", "foreign", "language", "can", "be", "challenging", "if", "you", "don't", "use", "it", "daily."],
          ["Even", "with", "basic", "grammar,", "reading", "everyday", "texts", "or", "media", "is", "tough."],
          ["EZ Knews", "changes", "that."],
          ["It", "helps", "beginner", "learners", "follow", "the", "news", "and", "read", "articles", "in", "their", "target", "language", "by", "providing", "simplified", "articles", "that", "are", "easy", "to", "understand,", "even", "for", "those", "just", "starting", "out."],
          ["Let's", "get", "started!"]
        ],
        3: [
          ["Mastering", "a", "foreign", "language", "is", "tough", "without", "daily", "immersion."],
          ["Beginners", "may", "know", "grammar,", "but", "real-world", "texts", "and", "media", "are", "often", "difficult."],
          ["EZ Knews", "solves", "this", "by", "making", "news", "accessible", "to", "language", "learners."],
          ["With", "simplified", "articles,", "you", "can", "keep", "up", "with", "global", "events", "and", "improve", "your", "skills,", "no", "matter", "your", "level."],
          ["Start", "your", "journey", "with", "EZ", "Knews", "today!"]
        ]
      } 
    },
    tokenizedTitle: { 
      en: { 
        1: [["EZ Knews", ":", "Global", "news", ",", "easy", "language"]],
        2: [["EZ Knews", ":", "Global", "news", ",", "easy", "language"]],
        3: [["EZ Knews", ":", "Global", "news", ",", "easy", "language"]]
      } 
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
  imageUrl: 'assets/images/logo.png',
    originalUrl: '',
    // ...other fields as needed
  },
de: {
  id: 'de',
  language: 'de',
  title: {
    de: {
      1: 'EZ Knews: Globale Nachrichten, einfache Sprache',
      2: 'EZ Knews: Globale Nachrichten, einfache Sprache',
      3: 'EZ Knews: Globale Nachrichten, einfache Sprache'
    }
  },
  articleText: {
    de: {
      1: `Eine Fremdsprache zu lernen ist schwierig, wenn man nicht täglich in der Sprache lebt. Als Anfänger kann es selbst mit Grundkenntnissen der Grammatik eine Herausforderung sein, alltägliche Texte oder Medien zu verstehen. Mit EZ Knews ist das anders. EZ Knews macht es Anfängern leicht, mit den Nachrichten Schritt zu halten und Artikel in ihrer Zielsprache zu lesen, indem vereinfachte Artikel angeboten werden, die auch für Einsteiger verständlich sind! Los geht's!`,
      2: `Eine neue Sprache zu lernen kann schwierig sein, wenn man sie nicht täglich benutzt. Selbst mit Grundgrammatik ist das Lesen von Alltagstexten oder Medien oft schwer. EZ Knews ändert das. Es hilft Anfängern, die Nachrichten zu verfolgen und Artikel in ihrer Zielsprache zu lesen, indem es vereinfachte Artikel anbietet, die auch für Anfänger leicht verständlich sind. Fangen wir an!`,
      3: `Eine Fremdsprache zu meistern ist ohne tägliches Eintauchen schwierig. Anfänger kennen vielleicht die Grammatik, aber echte Texte und Medien sind oft schwer verständlich. EZ Knews löst dieses Problem, indem es Nachrichten für Sprachlernende zugänglich macht. Mit vereinfachten Artikeln kannst du globale Ereignisse verfolgen und deine Fähigkeiten verbessern – egal auf welchem Niveau du bist. Starte deine Reise mit EZ Knews noch heute!`
    }
  },
  tokenizedArticle: {
    de: {
      1: [
        ["Eine", "Fremdsprache", "zu", "lernen", "ist", "schwierig,", "wenn", "man", "nicht", "täglich", "in", "der", "Sprache", "lebt."],
        ["Als", "Anfänger", "kann", "es", "selbst", "mit", "Grundkenntnissen", "der", "Grammatik", "eine", "Herausforderung", "sein,", "alltägliche", "Texte", "oder", "Medien", "zu", "verstehen."],
        ["Mit", "EZ Knews", "ist", "das", "anders."],
        ["EZ Knews", "macht", "es", "Anfängern", "leicht,", "mit", "den", "Nachrichten", "Schritt", "zu", "halten", "und", "Artikel", "in", "ihrer", "Zielsprache", "zu", "lesen,", "indem", "vereinfachte", "Artikel", "angeboten", "werden,", "die", "auch", "für", "Einsteiger", "verständlich", "sind!"],
        ["Los", "geht's!"]
      ],
      2: [
        ["Eine", "neue", "Sprache", "zu", "lernen", "kann", "schwierig", "sein,", "wenn", "man", "sie", "nicht", "täglich", "benutzt."],
        ["Selbst", "mit", "Grundgrammatik", "ist", "das", "Lesen", "von", "Alltagstexten", "oder", "Medien", "oft", "schwer."],
        ["EZ Knews", "ändert", "das."],
        ["Es", "hilft", "Anfängern,", "die", "Nachrichten", "zu", "verfolgen", "und", "Artikel", "in", "ihrer", "Zielsprache", "zu", "lesen,", "indem", "es", "vereinfachte", "Artikel", "anbietet,", "die", "auch", "für", "Anfänger", "leicht", "verständlich", "sind."],
        ["Fangen", "wir", "an!"]
      ],
      3: [
        ["Eine", "Fremdsprache", "zu", "meistern", "ist", "ohne", "tägliches", "Eintauchen", "schwierig."],
        ["Anfänger", "kennen", "vielleicht", "die", "Grammatik,", "aber", "echte", "Texte", "und", "Medien", "sind", "oft", "schwer", "verständlich."],
        ["EZ Knews", "löst", "dieses", "Problem,", "indem", "es", "Nachrichten", "für", "Sprachlernende", "zugänglich", "macht."],
        ["Mit", "vereinfachten", "Artikeln", "kannst", "du", "globale", "Ereignisse", "verfolgen", "und", "deine", "Fähigkeiten", "verbessern", "–", "egal", "auf", "welchem", "Niveau", "du", "bist."],
        ["Starte", "deine", "Reise", "mit", "EZ Knews", "noch", "heute!"]
      ]
    }
  },
  tokenizedTitle: {
    de: {
      1: [["EZ Knews:", "Globale", "Nachrichten,", "einfache", "Sprache"]],
      2: [["EZ Knews:", "Globale", "Nachrichten,", "einfache", "Sprache"]],
      3: [["EZ Knews:", "Globale", "Nachrichten,", "einfache", "Sprache"]]
    }
  },
  publisher: 'EZ Knews',
  publisherIcon: '',
  imageUrl: 'assets/images/logo.png',
  originalUrl: '',
  // Add more languages as needed
},
  ar: {
    id: 'ar',
    language: 'ar',
    title: {
      ar: {
        1: 'EZ Knews: أخبار عالمية، لغة بسيطة',
        2: 'EZ Knews: أخبار عالمية، لغة بسيطة',
        3: 'EZ Knews: أخبار عالمية، لغة بسيطة'
      }
    },
    articleText: {
      ar: {
        1: `تعلم لغة أجنبية أمر صعب عندما لا تعيش في بيئة اللغة يوميًا. حتى لو كنت تعرف بعض قواعد النحو، فإن فهم النصوص الحقيقية قد يكون صعبًا. مع EZ Knews، الأمر مختلف. يساعد EZ Knews المبتدئين على مواكبة الأخبار وقراءة المقالات بلغتهم المستهدفة من خلال تقديم مقالات مبسطة سهلة الفهم. هيا بنا!`,
        2: `تعلم لغة أجنبية قد يكون تحديًا إذا لم تستخدمها يوميًا. حتى مع معرفة النحو الأساسي، فإن قراءة النصوص اليومية أو الوسائط صعبة. يغير EZ Knews ذلك. يساعد المتعلمين المبتدئين على متابعة الأخبار وقراءة المقالات بلغتهم المستهدفة من خلال توفير مقالات مبسطة سهلة الفهم، حتى لمن بدأ للتو. لنبدأ!`,
        3: `إتقان لغة أجنبية أمر صعب بدون الانغماس اليومي. قد يعرف المبتدئون النحو، لكن النصوص والوسائط في العالم الحقيقي غالبًا ما تكون صعبة. يحل EZ Knews هذه المشكلة من خلال جعل الأخبار متاحة لمتعلمي اللغة. مع مقالات مبسطة، يمكنك مواكبة الأحداث العالمية وتحسين مهاراتك، بغض النظر عن مستواك. ابدأ رحلتك مع EZ Knews اليوم!`
      }
    },
    tokenizedArticle: {
      ar: {
        1: [
          ["تعلم", "لغة", "أجنبية", "أمر", "صعب", "عندما", "لا", "تعيش", "في", "بيئة", "اللغة", "يوميًا."],
          ["حتى", "لو", "كنت", "تعرف", "بعض", "قواعد", "النحو،", "فإن", "فهم", "النصوص", "الحقيقية", "قد", "يكون", "صعبًا."],
          ["مع", "EZ Knews،", "الأمر", "مختلف."],
          ["يساعد", "EZ Knews", "المبتدئين", "على", "مواكبة", "الأخبار", "وقراءة", "المقالات", "بلغتهم", "المستهدفة", "من", "خلال", "تقديم", "مقالات", "مبسطة", "سهلة", "الفهم."],
          ["هيا", "بنا!"]
        ],
        2: [
          ["تعلم", "لغة", "أجنبية", "قد", "يكون", "تحديًا", "إذا", "لم", "تستخدمها", "يوميًا."],
          ["حتى", "مع", "معرفة", "النحو", "الأساسي،", "فإن", "قراءة", "النصوص", "اليومية", "أو", "الوسائط", "صعبة."],
          ["يغير", "EZ Knews", "ذلك."],
          ["يساعد", "المتعلمين", "المبتدئين", "على", "متابعة", "الأخبار", "وقراءة", "المقالات", "بلغتهم", "المستهدفة", "من", "خلال", "توفير", "مقالات", "مبسطة", "سهلة", "الفهم،", "حتى", "لمن", "بدأ", "للتو."],
          ["لنبدأ!"]
        ],
        3: [
          ["إتقان", "لغة", "أجنبية", "أمر", "صعب", "بدون", "الانغماس", "اليومي."],
          ["قد", "يعرف", "المبتدئون", "النحو،", "لكن", "النصوص", "والوسائط", "في", "العالم", "الحقيقي", "غالبًا", "ما", "تكون", "صعبة."],
          ["يحل", "EZ Knews", "هذه", "المشكلة", "من", "خلال", "جعل", "الأخبار", "متاحة", "لمتعلمي", "اللغة."],
          ["مع", "مقالات", "مبسطة،", "يمكنك", "مواكبة", "الأحداث", "العالمية", "وتحسين", "مهاراتك،", "بغض", "النظر", "عن", "مستواك."],
          ["ابدأ", "رحلتك", "مع", "EZ Knews", "اليوم!"]
        ]
      }
    },
    tokenizedTitle: {
      ar: {
        1: [["EZ Knews", ":", "أخبار", "عالمية", "،", "لغة", "بسيطة"]],
        2: [["EZ Knews", ":", "أخبار", "عالمية", "،", "لغة", "بسيطة"]],
        3: [["EZ Knews", ":", "أخبار", "عالمية", "،", "لغة", "بسيطة"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  hi: {
    id: 'hi',
    language: 'hi',
    title: {
      hi: {
        1: 'EZ Knews: वैश्विक समाचार, आसान भाषा',
        2: 'EZ Knews: वैश्विक समाचार, आसान भाषा',
        3: 'EZ Knews: वैश्विक समाचार, आसान भाषा'
      }
    },
    articleText: {
      hi: {
        1: `विदेशी भाषा सीखना मुश्किल है जब आप हर दिन उस भाषा में नहीं रहते। भले ही आपको कुछ व्याकरण पता हो, असली पाठ को समझना कठिन हो सकता है। EZ Knews के साथ, यह अलग है। EZ Knews शुरुआती लोगों को समाचारों के साथ अपडेट रहने और उनकी लक्षित भाषा में लेख पढ़ने में मदद करता है, सरल लेख प्रदान करके जो समझने में आसान हैं। चलो शुरू करें!`,
        2: `विदेशी भाषा सीखना चुनौतीपूर्ण हो सकता है अगर आप इसे रोज़ाना इस्तेमाल नहीं करते। बुनियादी व्याकरण के साथ भी, रोज़मर्रा के पाठ या मीडिया को पढ़ना मुश्किल है। EZ Knews इसे बदलता है। यह शुरुआती शिक्षार्थियों को समाचारों का अनुसरण करने और उनकी लक्षित भाषा में लेख पढ़ने में मदद करता है, सरल लेख प्रदान करके जो शुरुआत करने वालों के लिए भी समझने में आसान हैं। चलिए शुरू करते हैं!`,
        3: `बिना रोज़ाना डूबे विदेशी भाषा में महारत हासिल करना मुश्किल है। शुरुआती लोग शायद व्याकरण जानते हों, लेकिन वास्तविक दुनिया के पाठ और मीडिया अक्सर कठिन होते हैं। EZ Knews इसे हल करता है, भाषा सीखने वालों के लिए समाचार को सुलभ बनाकर। सरल लेखों के साथ, आप वैश्विक घटनाओं के साथ अपडेट रह सकते हैं और अपने कौशल को सुधार सकते हैं, चाहे आपका स्तर कुछ भी हो। EZ Knews के साथ अपनी यात्रा आज शुरू करें!`
      }
    },
    tokenizedArticle: {
      hi: {
        1: [
          ["विदेशी", "भाषा", "सीखना", "मुश्किल", "है", "जब", "आप", "हर", "दिन", "उस", "भाषा", "में", "नहीं", "रहते."],
          ["भले", "ही", "आपको", "कुछ", "व्याकरण", "पता", "हो,", "असली", "पाठ", "को", "समझना", "कठिन", "हो", "सकता", "है."],
          ["EZ Knews", "के", "साथ", "यह", "अलग", "है."],
          ["EZ Knews", "शुरुआती", "लोगों", "को", "समाचारों", "के", "साथ", "अपडेट", "रहने", "और", "उनकी", "लक्षित", "भाषा", "में", "लेख", "पढ़ने", "में", "मदद", "करता", "है", "सरल", "लेख", "प्रदान", "करके", "जो", "समझने", "में", "आसान", "हैं."],
          ["चलो", "शुरू", "करें!"]
        ],
        2: [
          ["विदेशी", "भाषा", "सीखना", "चुनौतीपूर्ण", "हो", "सकता", "है", "अगर", "आप", "इसे", "रोज़ाना", "इस्तेमाल", "नहीं", "करते."],
          ["बुनियादी", "व्याकरण", "के", "साथ", "भी", "रोज़मर्रा", "के", "पाठ", "या", "मीडिया", "को", "पढ़ना", "मुश्किल", "है."],
          ["EZ Knews", "इसे", "बदलता", "है."],
          ["यह", "शुरुआती", "शिक्षार्थियों", "को", "समाचारों", "का", "अनुसरण", "करने", "और", "उनकी", "लक्षित", "भाषा", "में", "लेख", "पढ़ने", "में", "मदद", "करता", "है", "सरल", "लेख", "प्रदान", "करके", "जो", "शुरुआत", "करने", "वालों", "के", "लिए", "भी", "समझने", "में", "आसान", "हैं."],
          ["चलिए", "शुरू", "करते", "हैं!"]
        ],
        3: [
          ["बिना", "रोज़ाना", "डूबे", "विदेशी", "भाषा", "में", "महारत", "हासिल", "करना", "मुश्किल", "है."],
          ["शुरुआती", "लोग", "शायद", "व्याकरण", "जानते", "हों", "लेकिन", "वास्तविक", "दुनिया", "के", "पाठ", "और", "मीडिया", "अक्सर", "कठिन", "होते", "हैं."],
          ["EZ Knews", "इसे", "हल", "करता", "है", "भाषा", "सीखने", "वालों", "के", "लिए", "समाचार", "को", "सुलभ", "बनाकर."],
          ["सरल", "लेखों", "के", "साथ", "आप", "वैश्विक", "घटनाओं", "के", "साथ", "अपडेट", "रह", "सकते", "हैं", "और", "अपने", "कौशल", "को", "सुधार", "सकते", "हैं", "चाहे", "आपका", "स्तर", "कुछ", "भी", "हो."],
          ["EZ Knews", "के", "साथ", "अपनी", "यात्रा", "आज", "शुरू", "करें!"]
        ]
      }
    },
    tokenizedTitle: {
      hi: {
        1: [["EZ Knews", ":", "वैश्विक", "समाचार", "।", "आसान", "भाषा"]],
        2: [["EZ Knews", ":", "वैश्विक", "समाचार", "।", "आसान", "भाषा"]],
        3: [["EZ Knews", ":", "वैश्विक", "समाचार", "।", "आसान", "भाषा"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  zh: {
    id: 'zh',
    language: 'zh',
    title: {
      zh: {
        1: 'EZ Knews：全球新闻，简单语言',
        2: 'EZ Knews：全球新闻，简单语言',
        3: 'EZ Knews：全球新闻，简单语言'
      }
    },
    articleText: {
      zh: {
        1: `学习外语如果不每天沉浸在语言环境中是很困难的。即使你懂得一些语法，理解真实文本也可能很困难。有了EZ Knews，情况就不同了。EZ Knews通过提供易于理解的简化文章，帮助初学者跟上新闻并用目标语言阅读文章。开始吧！`,
        2: `如果不每天使用外语，学习外语可能具有挑战性。即使掌握了基本语法，阅读日常文本或媒体也很困难。EZ Knews改变了这一点。它通过提供易于理解的简化文章，帮助初学者跟踪新闻并用目标语言阅读文章，即使是刚开始学习的人也能轻松理解。让我们开始吧！`,
        3: `没有每天的语言沉浸，掌握外语是很困难的。初学者可能懂得语法，但现实世界的文本和媒体往往很难理解。EZ Knews通过使新闻对语言学习者更易获取来解决这个问题。凭借简化的文章，你可以跟上全球事件并提升你的技能，无论你的水平如何。今天就用EZ Knews开始你的学习之旅吧！`
      }
    },
    tokenizedArticle: {
      zh: {
        1: [
          ["学习", "外语", "如果", "不", "每天", "沉浸", "在", "语言", "环境", "中", "是", "很", "困难", "的。"],
          ["即使", "你", "懂得", "一些", "语法，", "理解", "真实", "文本", "也", "可能", "很", "困难。"],
          ["有了", "EZ Knews，", "情况", "就", "不同", "了。"],
          ["EZ Knews", "通过", "提供", "易于", "理解", "的", "简化", "文章，", "帮助", "初学者", "跟上", "新闻", "并", "用", "目标", "语言", "阅读", "文章。"],
          ["开始", "吧！"]
        ],
        2: [
          ["如果", "不", "每天", "使用", "外语，", "学习", "外语", "可能", "具有", "挑战性。"],
          ["即使", "掌握", "了", "基本", "语法，", "阅读", "日常", "文本", "或", "媒体", "也", "很", "困难。"],
          ["EZ Knews", "改变", "了", "这", "一点。"],
          ["它", "通过", "提供", "易于", "理解", "的", "简化", "文章，", "帮助", "初学者", "跟踪", "新闻", "并", "用", "目标", "语言", "阅读", "文章，", "即使", "是", "刚", "开始", "学习", "的", "人", "也", "能", "轻松", "理解。"],
          ["让我们", "开始", "吧！"]
        ],
        3: [
          ["没有", "每天", "的", "语言", "沉浸，", "掌握", "外语", "是", "很", "困难", "的。"],
          ["初学者", "可能", "懂得", "语法，", "但", "现实", "世界", "的", "文本", "和", "媒体", "往往", "很", "难", "理解。"],
          ["EZ Knews", "通过", "使", "新闻", "对", "语言", "学习者", "更", "易", "获取", "来", "解决", "这", "个", "问题。"],
          ["凭借", "简化", "的", "文章，", "你", "可以", "跟上", "全球", "事件", "并", "提升", "你", "的", "技能，", "无论", "你", "的", "水平", "如何。"],
          ["今天", "就", "用", "EZ Knews", "开始", "你", "的", "学习", "之旅", "吧！"]
        ]
      }
    },
    tokenizedTitle: {
      zh: {
        1: [["EZ Knews", "：", "全球", "新闻", "，", "简单", "语言"]],
        2: [["EZ Knews", "：", "全球", "新闻", "，", "简单", "语言"]],
        3: [["EZ Knews", "：", "全球", "新闻", "，", "简单", "语言"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  ru: {
    id: 'ru',
    language: 'ru',
    title: {
      ru: {
        1: 'EZ Knews: Глобальные новости, простой язык',
        2: 'EZ Knews: Глобальные новости, простой язык',
        3: 'EZ Knews: Глобальные новости, простой язык'
      }
    },
    articleText: {
      ru: {
        1: `Изучение иностранного языка сложно, если вы не погружены в него каждый день. Даже если вы знаете основы грамматики, понимание реальных текстов может быть трудным. С EZ Knews всё иначе. EZ Knews помогает новичкам следить за новостями и читать статьи на целевом языке, предлагая упрощённые статьи, которые легко понять. Поехали!`,
        2: `Изучение иностранного языка может быть сложным, если вы не используете его ежедневно. Даже с базовой грамматикой чтение повседневных текстов или СМИ затруднительно. EZ Knews меняет это. Он помогает начинающим следить за новостями и читать статьи на целевом языке, предоставляя упрощённые статьи, которые легко понять даже для тех, кто только начинает. Давай начнём!`,
        3: `Овладеть иностранным языком сложно без ежедневного погружения. Новички могут знать грамматику, но реальные тексты и СМИ часто сложны для понимания. EZ Knews решает эту проблему, делая новости доступными для изучающих язык. С упрощёнными статьями вы можете следить за глобальными событиями и улучшать свои навыки, независимо от вашего уровня. Начните своё путешествие с EZ Knews сегодня!`
      }
    },
    tokenizedArticle: {
      ru: {
        1: [
          ["Изучение", "иностранного", "языка", "сложно,", "если", "вы", "не", "погружены", "в", "него", "каждый", "день."],
          ["Даже", "если", "вы", "знаете", "основы", "грамматики,", "понимание", "реальных", "текстов", "может", "быть", "трудным."],
          ["С", "EZ Knews", "всё", "иначе."],
          ["EZ Knews", "помогает", "новичкам", "следить", "за", "новостями", "и", "читать", "статьи", "на", "целевом", "языке,", "предлагая", "упрощённые", "статьи,", "которые", "легко", "понять."],
          ["Поехали!"]
        ],
        2: [
          ["Изучение", "иностранного", "языка", "может", "быть", "сложным,", "если", "вы", "не", "используете", "его", "ежедневно."],
          ["Даже", "с", "базовой", "грамматикой,", "чтение", "повседневных", "текстов", "или", "СМИ", "затруднительно."],
          ["EZ Knews", "меняет", "это."],
          ["Он", "помогает", "начинающим", "следить", "за", "новостями", "и", "читать", "статьи", "на", "целевом", "языке,", "предоставляя", "упрощённые", "статьи,", "которые", "легко", "понять,", "даже", "для", "тех,", "кто", "только", "начинает."],
          ["Давай", "начнём!"]
        ],
        3: [
          ["Овладеть", "иностранным", "языком", "сложно", "без", "ежедневного", "погружения."],
          ["Новички", "могут", "знать", "грамматику,", "но", "реальные", "тексты", "и", "СМИ", "часто", "сложны", "для", "понимания."],
          ["EZ Knews", "решает", "эту", "проблему,", "делая", "новости", "доступными", "для", "изучающих", "язык."],
          ["С", "упрощёнными", "статьями,", "вы", "можете", "следить", "за", "глобальными", "событиями", "и", "улучшать", "свои", "навыки,", "независимо", "от", "вашего", "уровня."],
          ["Начните", "своё", "путешествие", "с", "EZ Knews", "сегодня!"]
        ]
      }
    },
    tokenizedTitle: {
      ru: {
        1: [["EZ Knews", ":", "Глобальные", "новости", ",", "простой", "язык"]],
        2: [["EZ Knews", ":", "Глобальные", "новости", ",", "простой", "язык"]],
        3: [["EZ Knews", ":", "Глобальные", "новости", ",", "простой", "язык"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  fr: {
    id: 'fr',
    language: 'fr',
    title: {
      fr: {
        1: 'EZ Knews : Actualités mondiales, langage simple',
        2: 'EZ Knews : Actualités mondiales, langage simple',
        3: 'EZ Knews : Actualités mondiales, langage simple'
      }
    },
    articleText: {
      fr: {
        1: `Apprendre une langue étrangère est difficile lorsque vous n'êtes pas immergé dans la langue tous les jours. Même si vous connaissez un peu de grammaire, comprendre des textes réels peut être ardu. Avec EZ Knews, c'est différent. EZ Knews aide les débutants à suivre l'actualité et à lire des articles dans leur langue cible en proposant des articles simplifiés faciles à comprendre. Allons-y !`,
        2: `Apprendre une langue étrangère peut être un défi si vous ne l'utilisez pas quotidiennement. Même avec une grammaire de base, lire des textes quotidiens ou des médias est difficile. EZ Knews change cela. Il aide les apprenants débutants à suivre l'actualité et à lire des articles dans leur langue cible en fournissant des articles simplifiés faciles à comprendre, même pour ceux qui débutent. Commençons !`,
        3: `Maîtriser une langue étrangère est difficile sans immersion quotidienne. Les débutants peuvent connaître la grammaire, mais les textes et médias du monde réel sont souvent complexes. EZ Knews résout ce problème en rendant les actualités accessibles aux apprenants de langues. Avec des articles simplifiés, vous pouvez suivre les événements mondiaux et améliorer vos compétences, quel que soit votre niveau. Commencez votre voyage avec EZ Knews aujourd'hui !`
      }
    },
    tokenizedArticle: {
      fr: {
        1: [
          ["Apprendre", "une", "langue", "étrangère", "est", "difficile", "lorsque", "vous", "n'êtes", "pas", "immergé", "dans", "la", "langue", "tous", "les", "jours."],
          ["Même", "si", "vous", "connaissez", "un", "peu", "de", "grammaire,", "comprendre", "des", "textes", "réels", "peut", "être", "ardu."],
          ["Avec", "EZ Knews,", "c'est", "différent."],
          ["EZ Knews", "aide", "les", "débutants", "à", "suivre", "l'actualité", "et", "à", "lire", "des", "articles", "dans", "leur", "langue", "cible", "en", "proposant", "des", "articles", "simplifiés", "faciles", "à", "comprendre."],
          ["Allons-y!"]
        ],
        2: [
          ["Apprendre", "une", "langue", "étrangère", "peut", "être", "un", "défi", "si", "vous", "ne", "l'utilisez", "pas", "quotidiennement."],
          ["Même", "avec", "une", "grammaire", "de", "base,", "lire", "des", "textes", "quotidiens", "ou", "des", "médias", "est", "difficile."],
          ["EZ Knews", "change", "cela."],
          ["Il", "aide", "les", "apprenants", "débutants", "à", "suivre", "l'actualité", "et", "à", "lire", "des", "articles", "dans", "leur", "langue", "cible", "en", "fournissant", "des", "articles", "simplifiés", "faciles", "à", "comprendre,", "même", "pour", "ceux", "qui", "débutent."],
          ["Commençons!"]
        ],
        3: [
          ["Maîtriser", "une", "langue", "étrangère", "est", "difficile", "sans", "immersion", "quotidienne."],
          ["Les", "débutants", "peuvent", "connaître", "la", "grammaire,", "mais", "les", "textes", "et", "médias", "du", "monde", "réel", "sont", "souvent", "complexes."],
          ["EZ Knews", "résout", "ce", "problème", "en", "rendant", "les", "actualités", "accessibles", "aux", "apprenants", "de", "langues."],
          ["Avec", "des", "articles", "simplifiés,", "vous", "pouvez", "suivre", "les", "événements", "mondiaux", "et", "améliorer", "vos", "compétences,", "quel", "que", "soit", "votre", "niveau."],
          ["Commencez", "votre", "voyage", "avec", "EZ Knews", "aujourd'hui!"]
        ]
      }
    },
    tokenizedTitle: {
      fr: {
        1: [["EZ Knews", ":", "Actualités", "mondiales", ",", "langage", "simple"]],
        2: [["EZ Knews", ":", "Actualités", "mondiales", ",", "langage", "simple"]],
        3: [["EZ Knews", ":", "Actualités", "mondiales", ",", "langage", "simple"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  pt: {
    id: 'pt',
    language: 'pt',
    title: {
      pt: {
        1: 'EZ Knews: Notícias globais, linguagem simples',
        2: 'EZ Knews: Notícias globais, linguagem simples',
        3: 'EZ Knews: Notícias globais, linguagem simples'
      }
    },
    articleText: {
      pt: {
        1: `Aprender uma língua estrangeira é difícil quando você não está imerso na língua todos os dias. Mesmo conhecendo alguma gramática, entender textos reais pode ser desafiador. Com o EZ Knews, é diferente. O EZ Knews ajuda iniciantes a acompanhar as notícias e ler artigos na língua-alvo, oferecendo artigos simplificados que são fáceis de entender. Vamos lá!`,
        2: `Aprender uma língua estrangeira pode ser desafiador se você não a usa diariamente. Mesmo com gramática básica, ler textos cotidianos ou mídia é difícil. O EZ Knews muda isso. Ele ajuda aprendizes iniciantes a acompanhar as notícias e ler artigos na língua-alvo, fornecendo artigos simplificados que são fáceis de entender, mesmo para quem está começando. Vamos começar!`,
        3: `Dominar uma língua estrangeira é difícil sem imersão diária. Iniciantes podem conhecer gramática, mas textos e mídia do mundo real são muitas vezes complexos. O EZ Knews resolve isso tornando as notícias acessíveis para aprendizes de línguas. Com artigos simplificados, você pode acompanhar eventos globais e melhorar suas habilidades, independentemente do seu nível. Comece sua jornada com o EZ Knews hoje!`
      }
    },
    tokenizedArticle: {
      pt: {
        1: [
          ["Aprender", "uma", "língua", "estrangeira", "é", "difícil", "quando", "você", "não", "está", "imerso", "na", "língua", "todos", "os", "dias."],
          ["Mesmo", "conhecendo", "alguma", "gramática,", "entender", "textos", "reais", "pode", "ser", "desafiador."],
          ["Com", "o", "EZ Knews,", "é", "diferente."],
          ["O", "EZ Knews", "ajuda", "iniciantes", "a", "acompanhar", "as", "notícias", "e", "ler", "artigos", "na", "língua-alvo,", "oferecendo", "artigos", "simplificados", "que", "são", "fáceis", "de", "entender."],
          ["Vamos", "lá!"]
        ],
        2: [
          ["Aprender", "uma", "língua", "estrangeira", "pode", "ser", "desafiador", "se", "você", "não", "a", "usa", "diariamente."],
          ["Mesmo", "com", "gramática", "básica,", "ler", "textos", "cotidianos", "ou", "mídia", "é", "difícil."],
          ["O", "EZ Knews", "muda", "isso."],
          ["Ele", "ajuda", "aprendizes", "iniciantes", "a", "acompanhar", "as", "notícias", "e", "ler", "artigos", "na", "língua-alvo,", "fornecendo", "artigos", "simplificados", "que", "são", "fáceis", "de", "entender,", "mesmo", "para", "quem", "está", "começando."],
          ["Vamos", "começar!"]
        ],
        3: [
          ["Dominar", "uma", "língua", "estrangeira", "é", "difícil", "sem", "imersão", "diária."],
          ["Iniciantes", "podem", "conhecer", "gramática,", "mas", "textos", "e", "mídia", "do", "mundo", "real", "são", "muitas", "vezes", "complexos."],
          ["O", "EZ Knews", "resolve", "isso", "tornando", "as", "notícias", "acessíveis", "para", "aprendizes", "de", "línguas."],
          ["Com", "artigos", "simplificados,", "você", "pode", "acompanhar", "eventos", "globais", "e", "melhorar", "suas", "habilidades,", "independentemente", "do", "seu", "nível."],
          ["Comece", "sua", "jornada", "com", "o", "EZ Knews", "hoje!"]
        ]
      }
    },
    tokenizedTitle: {
      pt: {
        1: [["EZ Knews", ":", "Notícias", "globais", ",", "linguagem", "simples"]],
        2: [["EZ Knews", ":", "Notícias", "globais", ",", "linguagem", "simples"]],
        3: [["EZ Knews", ":", "Notícias", "globais", ",", "linguagem", "simples"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
  ja: {
    id: 'ja',
    language: 'ja',
    title: {
      ja: {
        1: 'EZ Knews：グローバルニュース、簡単な言語',
        2: 'EZ Knews：グローバルニュース、簡単な言語',
        3: 'EZ Knews：グローバルニュース、簡単な言語'
      }
    },
    articleText: {
      ja: {
        1: `外国語を学ぶのは、毎日その言語に浸かっていないと難しいです。文法を少し知っていても、実際のテキストを理解するのは大変です。EZ Knewsなら違います。EZ Knewsは、初心者がニュースを追いかけ、目標言語で記事を読むのを助けるために、理解しやすい簡略化された記事を提供します。さあ、始めましょう！`,
        2: `外国語を学ぶのは、毎日使わないと挑戦的です。基本的な文法を知っていても、日常のテキストやメディアを読むのは難しいです。EZ Knewsはそれを変えます。初心者の学習者がニュースを追いかけ、目標言語で記事を読むのを助けるために、初心者でも理解しやすい簡略化された記事を提供します。始めましょう！`,
        3: `毎日浸かることなく外国語をマスターするのは難しいです。初心者は文法を知っているかもしれませんが、実際のテキストやメディアはしばしば理解しづらいです。EZ Knewsは、言語学習者にニュースをアクセスしやすくすることでこの問題を解決します。簡略化された記事で、グローバルな出来事を追いかけ、どんなレベルでもスキルを向上させることができます。今日、EZ Knewsであなたの旅を始めましょう！`
      }
    },
    tokenizedArticle: {
      ja: {
        1: [
          ["外国語", "を", "学ぶ", "の", "は", "、", "毎日", "その", "言語", "に", "浸かって", "いない", "と", "難しい", "です", "。"],
          ["文法", "を", "少し", "知って", "いて", "も", "、", "実際の", "テキスト", "を", "理解", "する", "の", "は", "大変", "です", "。"],
          ["EZ Knews", "なら", "違い", "ます", "。"],
          ["EZ Knews", "は", "、", "初心者", "が", "ニュース", "を", "追いかけ", "、", "目標", "言語", "で", "記事", "を", "読む", "の", "を", "助ける", "ために", "、", "理解", "しやすい", "簡略化", "された", "記事", "を", "提供", "します", "。"],
          ["さあ", "、", "始め", "ましょう", "！"]
        ],
        2: [
          ["外国語", "を", "学ぶ", "の", "は", "、", "毎日", "使わ", "ない", "と", "挑戦的", "です", "。"],
          ["基本的な", "文法", "を", "知って", "いて", "も", "、", "日常の", "テキスト", "や", "メディア", "を", "読む", "の", "は", "難しい", "です", "。"],
          ["EZ Knews", "は", "それ", "を", "変え", "ます", "。"],
          ["初心者", "の", "学習者", "が", "ニュース", "を", "追いかけ", "、", "目標", "言語", "で", "記事", "を", "読む", "の", "を", "助ける", "ために", "、", "初心者", "でも", "理解", "しやすい", "簡略化", "された", "記事", "を", "提供", "します", "。"],
          ["始め", "ましょう", "！"]
        ],
        3: [
          ["毎日", "浸かる", "こと", "なく", "外国語", "を", "マスター", "する", "の", "は", "難しい", "です", "。"],
          ["初心者", "は", "文法", "を", "知って", "いる", "かも", "しれ", "ませ", "ん", "が", "、", "実際の", "テキスト", "や", "メディア", "は", "しばしば", "理解", "しづらい", "です", "。"],
          ["EZ Knews", "は", "、", "言語", "学習者", "に", "ニュース", "を", "アクセス", "しやすく", "する", "こと", "で", "この", "問題", "を", "解決", "します", "。"],
          ["簡略化", "された", "記事", "で", "、", "グローバル", "な", "出来事", "を", "追いかけ", "、", "どんな", "レベル", "でも", "スキル", "を", "向上", "させる", "こと", "が", "でき", "ます", "。"],
          ["今日", "、", "EZ Knews", "で", "あなた", "の", "旅", "を", "始め", "ましょう", "！"]
        ]
      }
    },
    tokenizedTitle: {
      ja: {
        1: [["EZ Knews", "：", "グローバル", "ニュース", "、", "簡単な", "言語"]],
        2: [["EZ Knews", "：", "グローバル", "ニュース", "、", "簡単な", "言語"]],
        3: [["EZ Knews", "：", "グローバル", "ニュース", "、", "簡単な", "言語"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  },
    es: {
    id: 'es',
    language: 'es',
    title: {
      es: {
        1: 'EZ Knews: Noticias globales, lenguaje sencillo',
        2: 'EZ Knews: Noticias globales, lenguaje sencillo',
        3: 'EZ Knews: Noticias globales, lenguaje sencillo'
      }
    },
    articleText: {
      es: {
        1: `Aprender un idioma extranjero es difícil cuando no estás inmerso en él todos los días. Aunque sepas algo de gramática, entender textos reales puede ser complicado. Con EZ Knews, es diferente. EZ Knews ayuda a los principiantes a seguir las noticias y leer artículos en su idioma objetivo ofreciendo artículos simplificados que son fáciles de entender. ¡Vamos!`,
        2: `Aprender un idioma extranjero puede ser un desafío si no lo usas a diario. Incluso con gramática básica, leer textos cotidianos o medios es difícil. EZ Knews cambia eso. Ayuda a los aprendices principiantes a seguir las noticias y leer artículos en su idioma objetivo proporcionando artículos simplificados que son fáciles de entender, incluso para los que recién comienzan. ¡Empecemos!`,
        3: `Dominar un idioma extranjero es difícil sin inmersión diaria. Los principiantes pueden conocer la gramática, pero los textos y medios del mundo real suelen ser complejos. EZ Knews resuelve esto haciendo que las noticias sean accesibles para los aprendices de idiomas. Con artículos simplificados, puedes seguir los eventos globales y mejorar tus habilidades, sin importar tu nivel. ¡Comienza tu viaje con EZ Knews hoy!`
      }
    },
    tokenizedArticle: {
      es: {
        1: [
          ["Aprender", "un", "idioma", "extranjero", "es", "difícil", "cuando", "no", "estás", "inmerso", "en", "él", "todos", "los", "días."],
          ["Aunque", "sepas", "algo", "de", "gramática,", "entender", "textos", "reales", "puede", "ser", "complicado."],
          ["Con", "EZ Knews,", "es", "diferente."],
          ["EZ Knews", "ayuda", "a", "los", "principiantes", "a", "seguir", "las", "noticias", "y", "leer", "artículos", "en", "su", "idioma", "objetivo", "ofreciendo", "artículos", "simplificados", "que", "son", "fáciles", "de", "entender."],
          ["¡Vamos!"]
        ],
        2: [
          ["Aprender", "un", "idioma", "extranjero", "puede", "ser", "un", "desafío", "si", "no", "lo", "usas", "a", "diario."],
          ["Incluso", "con", "gramática", "básica,", "leer", "textos", "cotidianos", "o", "medios", "es", "difícil."],
          ["EZ Knews", "cambia", "eso."],
          ["Ayuda", "a", "los", "aprendices", "principiantes", "a", "seguir", "las", "noticias", "y", "leer", "artículos", "en", "su", "idioma", "objetivo", "proporcionando", "artículos", "simplificados", "que", "son", "fáciles", "de", "entender,", "incluso", "para", "los", "que", "recién", "comienzan."],
          ["¡Empecemos!"]
        ],
        3: [
          ["Dominar", "un", "idioma", "extranjero", "es", "difícil", "sin", "inmersión", "diaria."],
          ["Los", "principiantes", "pueden", "conocer", "la", "gramática,", "pero", "los", "textos", "y", "medios", "del", "mundo", "real", "suelen", "ser", "complejos."],
          ["EZ Knews", "resuelve", "esto", "haciendo", "que", "las", "noticias", "sean", "accesibles", "para", "los", "aprendices", "de", "idiomas."],
          ["Con", "artículos", "simplificados,", "puedes", "seguir", "los", "eventos", "globales", "y", "mejorar", "tus", "habilidades,", "sin", "importar", "tu", "nivel."],
          ["¡Comienza", "tu", "viaje", "con", "EZ Knews", "hoy!"]
        ]
      }
    },
    tokenizedTitle: {
      es: {
        1: [["EZ Knews", ":", "Noticias", "globales", ",", "lenguaje", "sencillo"]],
        2: [["EZ Knews", ":", "Noticias", "globales", ",", "lenguaje", "sencillo"]],
        3: [["EZ Knews", ":", "Noticias", "globales", ",", "lenguaje", "sencillo"]]
      }
    },
    publisher: 'EZ Knews',
    publisherIcon: '',
    imageUrl: 'assets/images/logo.png',
    originalUrl: ''
  }
};